export default __webpack_public_path__ + "static/media/NanumSquareEB.7f267188.woff";